exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-bottom[data-v-1323807d]{position:fixed;height:50px!important;background-color:#fff;display:none}.sticky-bottom[data-v-1323807d]{margin-top:60px;padding-bottom:60px}.container[data-v-1323807d]{color:#6f65ca}#logo[data-v-1323807d]{height:30px;margin-right:20px;margin-bottom:15px;display:inline-block}@media (min-width:768px){.text-content[data-v-1323807d]{text-align:right}#logo[data-v-1323807d]{margin-bottom:0}}p[data-v-1323807d]{color:rgba(0,0,0,.76);font-size:14px;margin-bottom:0;padding-bottom:0}.copyright[data-v-1323807d]{color:rgba(0,0,0,.5);font-size:12px;padding-top:3px}", ""]);

// exports
